<template>
  <div>
    <div class="card">
      <div class="card-header">
        Run Report
      </div>
      <div class="card-body">
        <form v-on:submit.prevent="runJob">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-5">
              <div class="form-group">
                <v-select
                  name="Report type"
                  v-model="options.module"
                  :options="modules"
                  placeholder="Select a report..."
                  v-validate="'required'"
                  data-vv-value-path="options.module.value"
                  data-vv-name="module"
                ></v-select>
                <div v-show="errors.has('module')" class="bg-warning">{{ errors.first('module') }}</div>
              </div>
            </div>
            <div class="col-12 col-sm-10 col-md-10 col-lg-6">
              <div v-if="options.module && options.module.value == 'gather-places'" class="row">
                <div class="col-12 col-sm-8">
                  <div class="form-group">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Places business name..."
                      v-model="options.businessName"
                    />
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="form-check">
                    <div class="form-check-label">
                      <input
                        type="checkbox"
                        v-model="options.strict"
                      />
                      Strict Match
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12 col-sm-6">
                  <v-select
                    v-model="options.client"
                    :options="clients"
                    placeholder="Select a client..."
                    v-validate="'required'"
                    data-vv-name="client"
                  ></v-select>
                  <div v-show="errors.has('client')" class="bg-warning">{{ errors.first('client') }}</div>
                </div>
                <div class="col-12 col-sm-6" v-if="posts">
                  <v-select
                    v-model="options.file"
                    :options="files.posts"
                    placeholder="Select a file..."
                    v-validate="posts ? 'required' : ''"
                    data-vv-name="file"
                  ></v-select>
                  <div v-show="errors.has('file')" class="bg-warning">{{ errors.first('file') }}</div>
                </div>
                <div class="col-12 col-sm-6" v-if="!posts">
                  <input
                    type="month"
                    name="stamp"
                    class="form-control"
                    v-model="options.stamp"
                    v-validate="posts ? '' : 'required'"
                  />
                  <div v-show="errors.has('stamp')" class="bg-warning">{{ errors.first('stamp') }}</div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-2 col-md-1">
              <button type="submit" class="btn btn-primary">Run</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="table-header clearfix">

      <h4 class="table-title pull-left"></h4>
    </div>
    <div class="card">
      <div class="card-header">
        Reporting Jobs
        <div class="actions pull-right">
          <b-dropdown id="legend" text="Legend" right variant="primary" class="m-md-2">
            <b-dropdown-item>
               <i title="Job has been submitted" class="text-primary fa fa-hourglass-o" aria-hidden="true"></i>
                Job submitted
            </b-dropdown-item>
            <b-dropdown-item>
               <i title="Job has been accepted" class="text-primary fa fa-hourglass-start" aria-hidden="true"></i>
               Job accepted
            </b-dropdown-item>
            <b-dropdown-item>
               <i title="Job is waiting on resources" class="text-primary fa fa-hourglass-half" aria-hidden="true"></i>
               Job queued
            </b-dropdown-item>
            <b-dropdown-item>
               <i title="Job is getting ready to run" class="text-primary fa fa-hourglass-end" aria-hidden="true"></i>
               Job starting
            </b-dropdown-item>
            <b-dropdown-item>
               <i title="Job is in progress" class="text-primary fa fa-spinner fa-spin" aria-hidden="true"></i>
               Job in progress
            </b-dropdown-item>
            <b-dropdown-item>
               <i title="Job completed" class="text-success fa fa-check" aria-hidden="true"></i>
               Job completed
            </b-dropdown-item>
            <b-dropdown-item>
               <i title="Job did not finish" class="text-danger fa fa-times" aria-hidden="true"></i>
               Job failed
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div class="card-body">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :defaultSortBy="{field: 'createdAt', type: 'desc'}"
          :globalSearch="true"
          :paginate="true"
          :perPage="50"
          styleClass="table condensed table-bordered table-striped">
          <template slot="table-column" scope="props">
             <span v-if="props.column.label === 'Status'">
                <span class="hidden-xs">
                  {{props.column.label}}
                </span>
                <i class="fa fa-wrench" aria-hidden="true" :title="props.column.label"></i>
             </span>
             <span v-else>
                {{props.column.label}}
             </span>
          </template>
          <template slot="table-row" scope="props">
            <td class="fancy">{{ props.row.name }}</td>
            <td class="text-center">
              <span v-if="props.row.status === 'SUBMITTED'">
                <i title="Job has been submitted" class="text-primary fa fa-2x fa-hourglass-o" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.status === 'PENDING'">
                <i title="Job has been accepted" class="text-primary fa fa-2x fa-hourglass-start" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.status === 'RUNNABLE'">
                <i title="Job is waiting on resources" class="text-primary fa fa-2x fa-hourglass-half" aria-hidden="true"></i>
              </span>
              <span v-else-if="props.row.status === 'STARTING'">
                <i title="Job is getting ready to run" class="text-primary fa fa-2x fa-hourglass-end" aria-hidden="true"></i>
              </span>
              <span v-else>
                <router-link :to="{ name: 'Job Report', params: { jobId: props.row.jobId }}">
                  <span v-if="props.row.status === 'SUCCEEDED'">
                    <i title="Job completed" class="text-success fa fa-2x fa-check" aria-hidden="true"></i>
                  </span>
                  <span v-else-if="props.row.status === 'FAILED'">
                    <i title="Job did not finish" class="text-danger fa fa-2x fa-times" aria-hidden="true"></i>
                  </span>
                  <span v-else-if="props.row.status === 'RUNNING'">
                    <i title="Job is in progress" class="text-primary fa fa-2x fa-spinner fa-spin" aria-hidden="true"></i>
                  </span>
                </router-link>
              </span>
            </td>
            <td class="text-center">
              {{ props.row.createdAt | moment("h:mm a") }}
            </td>
          </template>
        </vue-good-table>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
  import { PrMJobs } from '../services/prm-jobs'
  import vSelect from 'vue-select'

  let prmJobs

  export default {
    name: 'presence-management',
    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval)
      next()
    },
    components: {
      vSelect
    },
    watch: {
      options: {
        handler (value) {
          const module = value.module.value

          this.posts = module === 'create-posts' || module === 'delete-posts'
        },
        deep: true
      }
    },
    data () {
      let date = new Date(Date.now())

      date.setMonth(date.getMonth() - 1)

      return {
        posts: false,
        options: {
          module: null,
          client: null,
          stamp: date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2),
          businessName: '',
          strict: true,
          post: null
        },
        columns: [{
          label: 'Report',
          field: 'name',
          filterable: true
        }, {
          label: 'Status',
          thClass: 'text-center'
        }, {
          label: 'Requested',
          field: 'createdAt',
          filterable: true,
          thClass: 'text-center'
        }],
        clients: [],
        files: {
          posts: []
        },
        rows: [],
        notifyState: { },
        modules: [{
          value: 'prm-report',
          label: 'Full Report'
        }, {
          value: 'gather-places',
          label: 'Get Google Places Data'
        }, {
          value: 'gather-gmb',
          label: 'Get Raw Google My Business Data'
        }, {
          value: 'gather-insights',
          label: 'Get Raw Insights Data'
        }, {
          value: 'create-posts',
          label: 'Create Posts in GMB'
        }, {
          value: 'delete-posts',
          label: 'Delete Posts in GMB'
        }, {
          value: 'gather-posts',
          label: 'Get Raw Posts Insights Data'
        }, {
          value: 'gather-reviews',
          label: 'Get Raw Review Data'
        }, {
          value: 'compare-nap',
          label: 'Create Raw Accuracy Report'
        }, {
          value: 'calculate-reviews',
          label: 'Create Review Report'
        }, {
          value: 'calculate-accuracy',
          label: 'Create Accuracy Report'
        }, {
          value: 'calculate-insights',
          label: 'Create Insights Report'
        }, {
          value: 'calculate-posts',
          label: 'Create Post Insights Report'
        }, {
          value: 'calculate-studio-insights',
          label: 'Create Data Studio Insights Report'
        }]
      }
    },
    methods: {
      refreshJobs () {
        this.$log.debug('Refreshing Jobs')

        prmJobs.getJobs().then((jobs) => {
          this.$log.debug('Received AWS Reporting Job Data', jobs)
          this.rows = jobs.map((job) => {
            let report = this.modules.find(module => module.value === job.parameters.module).label.split(' ')
            let client = this.clients.find(client => client.value === job.parameters.slug)
            let name = typeof client === 'object' ? client.label : job.parameters.businessName

            if (job.parameters.module !== 'gather-places') {
              report.push(job.parameters.stamp)
            }

            report.splice(1, 0, name)

            try {
              const key = job.jobId
              const state = job.status

              if (key in this.notifyState) {
                if (this.notifyState[key] !== state && this.notifyState[key] === 'RUNNING') {
                  this.$notification.show(report.join(' '), {
                    body: state
                  }, { })
                }
              }

              this.notifyState[key] = state
            } catch (error) {
              this.$log.error(error)
            }

            return {
              jobId: job.jobId,
              name: report.join(' '),
              status: job.status,
              createdAt: new Date(job.createdAt).toISOString()
            }
          })

          console.log(this.rows)
        }).catch((error) => {
          if (error.code === 'ExpiredTokenException' || error.code === 'CredentialsError') {
            this.$auth.signOut()
          } else {
            this.$log.warn(JSON.stringify(error))

            this.$notify({
              title: 'AWS API Error',
              text: error.message ? error.message : 'Gateway issue',
              type: 'alert-warning',
              duration: 5000
            })
          }
        })
      },
      runJob () {
        this.$validator.validateAll().then((status) => {
          if (status) {
            let job = {
              job: 'raptorPresenceManagementReport:2',
              queue: 'arn:aws:batch:us-east-1:976741133712:job-queue/raptorSchemaUpdates',
              name: 'raptorProductionPresenceManagementReport',
              parameters: {
                module: this.options.module.value,
                slug: (this.options.client && this.options.client.value) || 'false',
                stamp: this.options.stamp,
                file: (this.options.file && this.options.file.value) || '0',
                businessName: this.options.businessName || 'false',
                strict: this.options.strict ? 'true' : 'false'
              }
            }

            this.$dialog.confirm('<p>Are you sure you want to run this report?</p>', {
              loader: true,
              html: true,
              okText: 'Run Job',
              cancelText: 'Cancel'
            }).then((dialog) => {
              if (prmJobs) {
                prmJobs.runJob(job).then(() => {
                  dialog.close()
                  this.$notify({ title: 'The report has been queued' })
                  clearInterval(this.interval)
                  this.refreshJobs()
                  this.interval = setInterval(() => this.refreshJobs(), 15000)
                }, (error) => {
                  dialog.close()
                  this.$notify({
                    title: 'Unable to start job',
                    text: error.body.message || error.message || error.toString(),
                    type: 'alert-danger',
                    duration: 5000
                  })
                })
              }
            }).catch(() => {
              // Do nothing
            })
          }
        })
      }
    },
    mounted () {
      this.$log.debug('Presence management mounted')

      prmJobs = new PrMJobs(this)

      prmJobs.getClients().then((clients) => {
        this.$log.debug('Loaded clients')
        this.clients = clients.map((client) => {
          return {
            label: client.Client,
            value: client.Slug
          }
        }).sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0)

        this.refreshJobs()
        this.interval = setInterval(() => this.refreshJobs(), 15000)
      }).catch((error) => {
        this.$log.error(error)

        this.$notify({
          title: 'Unable to retrieve client list',
          text: 'Please try refreshing the page',
          type: 'alert-error',
          duration: 10000
        })
      })

      prmJobs.getPostsFiles().then((files) => {
        this.files.posts = files.filter(file => file.name.indexOf('Copy') === -1)
          .map(file => ({
            label: file.name,
            value: file.name
          }))
      }).catch((error) => {
        this.$log.error(error)

        this.$notify({
          title: 'Unable to Posts content list',
          text: 'Please try refreshing the page',
          type: 'alert-error',
          duration: 10000
        })
      })
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// PresenceManagement.vue?a7a9dbda